import { IBusinessObject } from '../PA.Core/PA.Core.IF.BO';
import { IMessageProvider, IProgressProvider, MessageType } from '../PA.Core/PA.Core.IF.Basic';
import { PAdbContext } from '../PA.Core/PAdbContext';
import { IdentityProvider } from "../PA.Core/Basic/Identity";
import {
    WB_UIAppSuiteRow,
    WB_UIAppSuiteAppRelationshipRow,
    WB_UIApplicationRow
} from "../PA.Core/PAdbSchemaRows";
import { ProgressProvider } from "../PA.Core/Basic/Progress";
import { MessageProvider } from "../PA.Core/Basic/Messages";
import {
    esWB_UI_Application,
    esWB_UI_AppSuite,
    esWB_UI_AppSuite_App_Relationship
} from "../PA.Core/PAdbSchema";
import { ASync } from "../PA.Core/Basic/ASync";
import { CreateOptions, ESRecordResolver } from "../PA.Core/lib/ESRecordResolver";
import { ESRecord } from "../PA.Core/lib/ESRecord";
import { ESDataStore } from "../PA.Core/lib/ESDataStore";
import _ = require('lodash');
import {
    SuiteAppChangeEvent,
    AppSuiteChangeEvent,
    IAppSuite
} from "../PA.UIFramework.Core/PA.UIFramework.IF.Aspects";
import { BehaviorSubject } from "rxjs";
import { PAEnvironment } from "../PA.Core/PAEnvironment";
import { RecordUtils } from "../PA.Core/Basic/Records";


export class UIAppSuiteBO implements IBusinessObject, IAppSuite {

    Identity: IdentityProvider;


    CreateOptions: any;

    LoadOptions: any;
    _bIsLoaded: boolean;
    _OnLoadComplete: Promise<IBusinessObject>;
    LoadProgressProvider: IProgressProvider;

    ValidateOptions: any;
    _bIsValidated: boolean;
    ValidateMessageProvider: IMessageProvider;
    ValidateProgressProvider: IProgressProvider;

    SaveOptions: any;
    _bIsSaved: boolean;
    SaveProgressProvider: IProgressProvider;

    DeleteOptions: any;
    _bIsDeleted: boolean;
    DeleteMessageProvider: IMessageProvider;
    DeleteProgressProvider: IProgressProvider;

    dbContext: PAdbContext;
    drWB_UIAppSuite: WB_UIAppSuiteRow;

    dctAuditedDeletes: { [id: number]: number }

    constructor(options?: any) {

        this.CreateOptions = options || {};

        if ('dbContext' in this.CreateOptions)
            this.dbContext = this.CreateOptions.dbContext;

        this.Identity = new IdentityProvider({ id: 0, name: 'New Suite' });

        this.LoadOptions = {};
        this._bIsLoaded = false;
        this._OnLoadComplete = undefined;
        this.LoadProgressProvider = new ProgressProvider('Loading', this);

        this.ValidateOptions = {};
        this._bIsValidated = false;
        this.ValidateMessageProvider = new MessageProvider();
        this.ValidateProgressProvider = new ProgressProvider("Validating", this);

        this.SaveOptions = {};
        this._bIsSaved = false;
        this.SaveProgressProvider = new ProgressProvider("Saving", this);

        this.DeleteOptions = {};
        this._bIsDeleted = false;
        this.DeleteMessageProvider = new MessageProvider();
        this.DeleteProgressProvider = new ProgressProvider("Deleting", this);

        this.drWB_UIAppSuite = undefined;

        this.IAppSuite_init()
    }

    get WB_UIAppSuite(): WB_UIAppSuiteRow {
        return this.drWB_UIAppSuite;
    }


    //<editor-fold desc = "IBusinessObject operations">


    async Copy(options?: any): Promise<IBusinessObject> {
        const self = this

        const src: UIAppSuiteBO = this;

        const tgt = new UIAppSuiteBO({});
        await tgt.LoadNew()

        if (!tgt.bIsLoaded)
            throw new Error("Unable to create New App Suite")

        RecordUtils.CopyProperties(tgt.dbContext, esWB_UI_AppSuite,
            src.WB_UIAppSuite, tgt.WB_UIAppSuite,
            [],
            ['DELETED_DT', 'DELETED_IND'],
            {})

        tgt.WB_UIAppSuite.cif.APPSUITE_ID = src.WB_UIAppSuite.cif.APPSUITE_ID + "_Copy"
        tgt.WB_UIAppSuite.cif.APPSUITE_NAME = src.WB_UIAppSuite.cif.APPSUITE_NAME + "_Copy"
        tgt.Identity.setAll(tgt.WB_UIAppSuite.cif.WB_UI_APPSUITE_ID, tgt.WB_UIAppSuite.cif.APPSUITE_ID, tgt.WB_UIAppSuite.cif.APPSUITE_NAME);

        for (let aRow of src.WB_UIAppSuite.WB_UIAppSuiteAppRelationshipRows) {
            if (!aRow.isActive)
                continue
            let appSuiteRel = await tgt.addAppSuiteRel(aRow.cif.WB_UI_APP_ID)
            appSuiteRel.cif.UI5_ICON_OVRD = aRow.cif.UI5_ICON_OVRD
            RecordUtils.CopyProperties(tgt.dbContext, esWB_UI_Application, aRow, appSuiteRel, [], [], {})

        }

        return tgt
    }

    LoadNew(options?: any): Promise<IBusinessObject> {
        const self = this;
        this.LoadProgressProvider.start("Creating Suite");

        let internalOnComplete = new Promise<IBusinessObject>((resolve, error) => {

            self.LoadOptions = options || {};
            if ('dbContext' in self.LoadOptions)
                self.dbContext = self.LoadOptions.dbContext;
            else
                self.dbContext = new PAdbContext();

            if (_.isEmpty(self.dbContext)) {
                var sError = "Unable to determine dbContext for new App Suite.";
                self.LoadProgressProvider.exception(sError);
                error(sError);
                return;
            }

            // Create record using dbContext
            this.dbContext.createRecordWithKey(esWB_UI_AppSuite)
                .then((newSuite: WB_UIAppSuiteRow) => {
                    newSuite.setDefaults()
                    self.drWB_UIAppSuite = newSuite;
                    self.drWB_UIAppSuite.cif.APPSUITE_NAME = "New App Suite"
                    self.dbContext.add(esWB_UI_AppSuite, newSuite)
                    self.Identity.setAll(self.WB_UIAppSuite.cif.WB_UI_APPSUITE_ID, self.WB_UIAppSuite.cif.APPSUITE_ID, self.WB_UIAppSuite.cif.APPSUITE_NAME);
                    self.LoadProgressProvider.setName("Loading " + self.Identity.name + "(" + self.Identity.id_ui + ")");
                    self.Identity.listenToRecordUpdates(self.WB_UIAppSuite, 'WB_UI_APPSUITE_ID', 'APPSUITE_ID', 'APPSUITE_NAME')

                    self.LoadProgressProvider.finish();
                    self._bIsLoaded = true;
                    self._OnLoadComplete = null;
                    resolve(self);

                })
                .catch((err) => {
                    self.LoadProgressProvider.exception(err)
                    error(err)
                })

        });

        self._OnLoadComplete = internalOnComplete

        return new Promise<IBusinessObject>((resolve, error) => {
            internalOnComplete
                .then((BO) => {
                    return ASync.resolve()
                }).then((ignored) => {
                self._bIsLoaded = true;
                self._OnLoadComplete = undefined
                self.LoadProgressProvider.finish()
                resolve(self)
            }).catch((err) => {
                self._OnLoadComplete = undefined
                self.LoadProgressProvider.exception(err)
                error(err)
            })
        })
    }

    Load(anId: number | number, options?: object): Promise<IBusinessObject> {

        const self = this;

        let recordResolver: ESRecordResolver
        let recordResolverLoadPromise: Promise<void>

        self.LoadProgressProvider.start("Loading (" + anId + ")");

        self._OnLoadComplete = new Promise<IBusinessObject>((resolve, error) => {

            if (self.bIsLoaded) {
                self.LoadProgressProvider.exception("Suite already loaded.")
                resolve(self); // "Suite already loaded.";
                return;
            }

            self.LoadOptions = options || {};
            _.defaults(self.LoadOptions, {})


            if ('dbContext' in self.LoadOptions)
                self.dbContext = self.LoadOptions.dbContext;
            else if (_.isEmpty(self.dbContext)) {
                self.dbContext = new PAdbContext({});
            }

            if (_.isEmpty(self.dbContext)) {
                error("Unable to determine dbContext for Suite.")
                return;
            }

            if ('RecordResolver' in self.LoadOptions) {
                recordResolver = (<any>self.LoadOptions).RecordResolver
                recordResolverLoadPromise = ASync.resolve()
            } else {
                recordResolver = UIAppSuiteBO.createRecordResolver({ dbContext: self.dbContext })
                recordResolverLoadPromise = UIAppSuiteBO.setupRecordResolver(recordResolver, [anId])
            }


            recordResolverLoadPromise
                .then(function() {
                    let aSuiteRow: any = recordResolver.get(esWB_UI_AppSuite, anId)

                    if (_.isEmpty(aSuiteRow)) {
                        error("Suite not Found");
                        return;
                    }

                    self.drWB_UIAppSuite = aSuiteRow;
                    self.Identity.setAll(self.WB_UIAppSuite.cif.WB_UI_APPSUITE_ID, self.WB_UIAppSuite.cif.APPSUITE_ID, self.WB_UIAppSuite.cif.APPSUITE_NAME);
                    self.LoadProgressProvider.setName("Loading " + self.Identity.name + "(" + self.Identity.id_ui + ")");
                    self.Identity.listenToRecordUpdates(self.WB_UIAppSuite, 'WB_UI_APPSUITE_ID', 'APPSUITE_ID', 'APPSUITE_NAME')
                    self._bIsLoaded = true
                    self._OnLoadComplete = undefined
                    self.LoadProgressProvider.finish()
                    resolve(self)
                }).catch(function(err: any) {
                self._OnLoadComplete = undefined
                self.LoadProgressProvider.exception(err)
                error(err)
                return;
            });

        });

        return this._OnLoadComplete;
    }

    get OnLoadComplete(): Promise<IBusinessObject> {
        return this._OnLoadComplete;
    }

    get bIsLoaded(): boolean {
        return this._bIsLoaded;
    }

    Validate(options?: any): Promise<IBusinessObject> {

        var self = this;
        this.ValidateMessageProvider.clearMessages();
        this.ValidateProgressProvider.start("Validating " + self.WB_UIAppSuite.cif.APPSUITE_NAME + "(" + self.WB_UIAppSuite.cif.APPSUITE_ID + ")");
        return new Promise<IBusinessObject>((resolve, reject) => {
            // Does no validations yet
            self.ValidateOptions = options || {};

            if (self.dbContext == undefined) {
                var sError = "Unable to determine dbContext for to Validate Suite.";
                self._bIsValidated = false;
                self.ValidateProgressProvider.exception(sError);
                reject(sError);
                return
            }

            ;(async () => {
                if (self.WB_UIAppSuite.cif.DELETED_IND != '1' && self.WB_UIAppSuite.cif.LANDING_PAGE_IND == '1') {
                    let arrSuite = await self.dbContext.findAll(esWB_UI_AppSuite, {
                        where: {
                            WB_UI_PROFILE_ID: self.WB_UIAppSuite.cif.WB_UI_PROFILE_ID,
                            LANDING_PAGE_IND: "1",
                            WB_UI_APPSUITE_ID: { neq: self.WB_UIAppSuite.cif.WB_UI_APPSUITE_ID },
                            DELETED_IND: { neq: '1' }
                        }
                    })

                    if (!_.isEmpty(arrSuite)) {
                        self.ValidateMessageProvider.addMessage({
                            type: MessageType.Error,
                            code: "LandingPageExists",
                            title: "Landing page exists for selected profile. Please select a different profile. ",
                            description: "",
                            subtitle: "",
                            count: 0
                        });
                        self._bIsValidated = false
                    } else {
                        self._bIsValidated = true;
                    }
                } else {
                    self._bIsValidated = true;
                }
                self.ValidateProgressProvider.finish();
                resolve(self);
            })();

        });
    }

    get bIsValidated(): boolean {
        return this._bIsValidated;
    }


    Save(options?: any): Promise<IBusinessObject> {
        return this.SaveUsing(false, options)
    }


    SaveBatch(options?: any): Promise<IBusinessObject> {
        return this.SaveUsing(true, options)
    }

    SaveUsing(bBatch: boolean, options?: any): Promise<IBusinessObject> {

        var self = this;

        this.SaveProgressProvider.start("Saving " + self.WB_UIAppSuite.cif.APPSUITE_NAME + "(" + self.WB_UIAppSuite.cif.APPSUITE_ID + ")");

        return new Promise<IBusinessObject>((resolve, reject) => {
            // Doesn't need to do anything yet
            // All the records are in the store, since they were added through find or createNewRecord.
            // -- We could search the tree if the there is any record where store isn't set.

            if (self.dbContext == undefined) {
                self._bIsSaved = false;
                var sError = "Unable to determine dbContext to Save Suite.";
                self.SaveProgressProvider.exception(sError);
                reject(sError);
                return
            }

            self.SaveOptions = options || {};
            var saveFunction: (esName: string, saveRecords: ESRecord[] | ESRecord, options?: any) => Promise<ESDataStore>
            if (bBatch) {
                saveFunction = self.dbContext.SaveBatch.bind(self.dbContext)
            } else {
                saveFunction = self.dbContext.Save.bind(self.dbContext)
            }

            let bDone = false
            self.Validate({})
                .then((ignore) => {
                    if (self.ValidateMessageProvider.countMessages(MessageType.Error) > 0) {
                        self._bIsSaved = false;
                        self.SaveProgressProvider.finish();
                        bDone = true
                        resolve(self);
                        return
                    }
                })
                .then(() => {
                    return saveFunction(esWB_UI_AppSuite, self.drWB_UIAppSuite, {})
                })
                .then((ignored) => {
                    var tasks: Promise<any>[] = [];
                    tasks.push(saveFunction(esWB_UI_AppSuite_App_Relationship, self.drWB_UIAppSuite.WB_UIAppSuiteAppRelationshipRows));
                    return Promise.all(tasks)
                }).then((ignored) => {
                if (bDone) return
                if (bBatch) {
                    self.dbContext.addBatchCompleteListener(() => {
                        self._bIsSaved = true;
                    })
                } else {
                    self._bIsSaved = true;
                }
                self.SaveProgressProvider.finish();
            })
                .then((ignored) => {
                    resolve(self);
                })
                .catch((err) => {
                    self.SaveProgressProvider.exception(err);
                    resolve(self)
                })

        })
    }

    get bIsSaved(): boolean {
        return this._bIsSaved;
    }

//Delete------------------------------------------------------------------------
    Delete(options?: any): Promise<IBusinessObject> {
        return this.DeleteUsing(true, options)
    }

    DeleteOnSave(options?: any): Promise<IBusinessObject> {
        return this.DeleteUsing(false, options)
    }

    private DeleteUsing(bSaveNow: boolean, options?: any): Promise<IBusinessObject> {
        var self = this;

        this.DeleteMessageProvider.clearMessages();
        this.DeleteProgressProvider.start("Deleting " + self.WB_UIAppSuite.cif.APPSUITE_NAME + "(" + self.WB_UIAppSuite.cif.APPSUITE_ID + ")");
        return new Promise<IBusinessObject>((resolve, error) => {

            // 1. Validate if we can delete the Suite

            // 2. If Valid, mark all the records for deletion.
            self.drWB_UIAppSuite.markDeleted()
            _.forEach(this.WB_UIAppSuite.WB_UIAppSuiteAppRelationshipRows, aRow => {
                aRow.markDeleted()
            })

            if (bSaveNow) {
                self.SaveUsing(false)
                    .then((ignore) => {
                        self._bIsDeleted = true;
                        self.DeleteProgressProvider.finish();
                        resolve(self);

                    })
                    .catch((err) => {
                        this.DeleteProgressProvider.exception(err)
                        resolve(self)
                    })
            } else {
                self._bIsDeleted = true;
                self.DeleteProgressProvider.finish();
                resolve(self);
            }
        });
    }

    get bIsDeleted(): boolean {
        return this._bIsDeleted;
    }

    //</editor-fold>

    //<editor-fold desc = "IRecordResolver Operations">

    static setupRecordResolver(recordResolver: ESRecordResolver, ids: string[] | number[]): Promise<void> {

        return new Promise<void>((resolve, error) => {
            recordResolver.findAllWithRelationships(esWB_UI_AppSuite, ids).then((result) => {
                resolve()
            }).catch((err) => {
                error(err)
            })
        })
    }

    static concurrentLoadCountHint(): number {
        return 10;
    }

    static createRecordResolver(boLoadOptions: any): ESRecordResolver {

        let opts = boLoadOptions || {}
        let dbContext: PAdbContext

        if ('dbContext' in opts) {
            dbContext = opts.dbContext;
        } else {
            dbContext = new PAdbContext({});
        }
        const wrksp_options: CreateOptions = {
            standardConditions: {
                [esWB_UI_AppSuite]: { "DELETED_IND": { "notIn": ['1'] } },
                [esWB_UI_AppSuite_App_Relationship]: { "DELETED_IND": { "notIn": ['1'] } }
            },
            dctIncludeBelongsToNamedRelations: {}
        }

        const aRecResolver = new ESRecordResolver(dbContext, wrksp_options)

        return aRecResolver;

    }

    //</editor-fold>

    private _AppSuitePropertyChanged: BehaviorSubject<AppSuiteChangeEvent>;
    private _SuiteAppPropertyChanged: BehaviorSubject<SuiteAppChangeEvent>;
    private _SuiteAppCollectionChanged: BehaviorSubject<IAppSuite>;


    private IAppSuite_init() {
        this._AppSuitePropertyChanged = new BehaviorSubject<AppSuiteChangeEvent>(undefined)
        this._SuiteAppPropertyChanged = new BehaviorSubject<SuiteAppChangeEvent>(undefined)
        this._SuiteAppCollectionChanged = new BehaviorSubject<IAppSuite>(undefined)
    }


    private IAppSuite_OnLoadComplete(): Promise<void> {
        const self = this

        return new Promise<void>((resolve, error) => {
            self.WB_UIAppSuite.setupOnChangeEvents([], self.IAppSuite_onAppSuitePRecordChange.bind(self), self)

            _.forEach(self.WB_UIAppSuite.WB_UIAppSuiteAppRelationshipRows, (aRow) => {
                if (!aRow.isActive) {
                    return
                }
                aRow.setupOnChangeEvents([], self.IAppSuite_onSuiteAppRecordChange.bind(self), self)
            })

            resolve()
        })
    }


    private IAppSuite_onAppSuitePRecordChange(record: WB_UIAppSuiteRow, propertyName: string, propertyValue: any, options: UIAppSuiteBO) {
        this.OnAppSuitePropertyChanged.next({
            UIAppSuiteBO: options,
            Row: record,
            PropertyChanged: propertyName,
            PropertyValue: propertyValue
        })
    }

    private IAppSuite_onSuiteAppRecordChange(record: WB_UIAppSuiteAppRelationshipRow, propertyName: string, propertyValue: any, options: UIAppSuiteBO) {
        this.onSuiteAppPropertyChanged.next({
            UIAppSuiteBO: options,
            Row: record,
            PropertyChanged: propertyName,
            PropertyValue: propertyValue
        })
    }


    get OnSuiteAppCollectionChanged(): BehaviorSubject<IAppSuite> {
        return this._SuiteAppCollectionChanged
    }


    get OnAppSuitePropertyChanged(): BehaviorSubject<AppSuiteChangeEvent> {
        return this._AppSuitePropertyChanged
    }

    get onSuiteAppPropertyChanged(): BehaviorSubject<SuiteAppChangeEvent> {
        return this._SuiteAppPropertyChanged
    }


    //<editor-fold desc = "App-Suite relationship operations">
    addAppSuiteRel(anAppId: number): Promise<WB_UIAppSuiteAppRelationshipRow> {

        const self = this

        return new Promise<WB_UIAppSuiteAppRelationshipRow>((resolve, error) => {
            // first find out if record exists.
            var found = false

            _.forEach(self.WB_UIAppSuite.WB_UIAppSuiteAppRelationshipRows, (anAppRelRow: WB_UIAppSuiteAppRelationshipRow) => {
                if (anAppRelRow.isActive && anAppRelRow.cif.WB_UI_APP_ID == anAppId) {
                    found = true
                }
            })

            if (found) {
                resolve()
                return
            } // exists..

            let anAppRow: WB_UIApplicationRow = undefined
            let anAppSuiteRelRow: WB_UIAppSuiteAppRelationshipRow = undefined
            let iSort: number = 0
            self.dbContext.find(esWB_UI_Application, anAppId)
                .then((anAppRecord: WB_UIApplicationRow) => {
                    if (_.isEmpty(anAppRecord)) {
                        // Bad User Role Id...
                        resolve()
                        return
                    }
                    anAppRow = anAppRecord

                    let rows = _.orderBy(self.drWB_UIAppSuite.WB_UIAppSuiteAppRelationshipRows, ["SORT_ORDER"], ["desc"])
                    if (rows.length > 0)
                        iSort = rows[0].cif.SORT_ORDER + 1


                    return self.dbContext.createRecordWithKey(esWB_UI_AppSuite_App_Relationship)
                })
                .then((aNewRow: WB_UIAppSuiteAppRelationshipRow) => {
                    if (!aNewRow) {
                        resolve(undefined)
                        return
                    }
                    aNewRow.setDefaults();
                    anAppSuiteRelRow = aNewRow
                    anAppSuiteRelRow.cif.WB_UI_APP_ID = anAppId
                    anAppSuiteRelRow.cif.WB_UI_APPSUITE_ID = self.drWB_UIAppSuite.cif.WB_UI_APPSUITE_ID;
                    anAppSuiteRelRow.WB_UIAppSuiteRow = self.drWB_UIAppSuite
                    anAppSuiteRelRow.WB_UIApplicationRow = anAppRow
                    anAppSuiteRelRow.cif.APP_NAME_OVRD = anAppRow.cif.APP_NAME
                    anAppSuiteRelRow.cif.GROUP_NAME_OVRD = anAppRow.cif.GROUP_NAME
                    anAppSuiteRelRow.cif.RENDER_OPTIONS = anAppRow.cif.RENDER_OPTIONS
                    anAppSuiteRelRow.cif.SORT_ORDER = anAppRow.cif.SORT_ORDER
                    anAppSuiteRelRow.cif.LAUNCH_POLICY = anAppRow.cif.LAUNCH_POLICY
                    anAppSuiteRelRow.cif.UI5_ICON_OVRD = anAppRow.cif.UI5_ICON
                    anAppSuiteRelRow.cif.RENDER_OPTIONS = anAppRow.cif.RENDER_OPTIONS
                    anAppSuiteRelRow.cif.SORT_ORDER = iSort
                    self.dbContext.add(esWB_UI_AppSuite_App_Relationship, aNewRow)
                    anAppSuiteRelRow.setupOnChangeEvents([], self.IAppSuite_onSuiteAppRecordChange.bind(self), self)
                    self.OnSuiteAppCollectionChanged.next(self)

                    resolve(aNewRow)
                })
                .catch((err) => {
                    error(err)
                })
        })

    }

    removeAppSuiteRel(aWbRelId: number): Promise<void> {
        let self = this

        return new Promise<void>((resolve, error) => {

            _.forEach(self.drWB_UIAppSuite.WB_UIAppSuiteAppRelationshipRows, (aRelRow: WB_UIAppSuiteAppRelationshipRow) => {
                if (aRelRow.isActive && aRelRow.cif.WB_UI_APPSUITEAR_ID == aWbRelId) {
                    aRelRow.markDeleted()
                    aRelRow.off()  // Turn off Event Generation
                }
            })
            self.OnSuiteAppCollectionChanged.next(self)
            resolve()
        })

    }

    get AppSuiteRels(): WB_UIAppSuiteAppRelationshipRow[] {
        return _.orderBy(this.WB_UIAppSuite.WB_UIAppSuiteAppRelationshipRows, ['SORT_ORDER'], ['asc'])
    }

    //</editor-fold>


};
PAEnvironment.registerBusinessObjectClass(UIAppSuiteBO, "UIAppSuiteBO", "App Suite")